import { create } from "zustand";
import { team as seed } from "@/mocks/seed";
import type { TeamMember } from "@/types";

/** Mock store for team members when unauthenticated / API down (Phase 5.4). */
interface TeamState {
  active: TeamMember[];
  archived: TeamMember[];
  add: (member: TeamMember) => void;
  update: (id: string, patch: Partial<TeamMember>) => void;
  archive: (id: string) => void;
  restore: (id: string) => void;
}

export const useTeamStore = create<TeamState>((set) => ({
  active: seed,
  archived: [],
  add: (member) => set((s) => ({ active: [...s.active, member] })),
  update: (id, patch) =>
    set((s) => ({ active: s.active.map((m) => (m.id === id ? { ...m, ...patch } : m)) })),
  archive: (id) =>
    set((s) => {
      const target = s.active.find((m) => m.id === id);
      if (!target) return s;
      return { active: s.active.filter((m) => m.id !== id), archived: [target, ...s.archived] };
    }),
  restore: (id) =>
    set((s) => {
      const target = s.archived.find((m) => m.id === id);
      if (!target) return s;
      return { archived: s.archived.filter((m) => m.id !== id), active: [...s.active, target] };
    }),
}));
